export const TeamIcon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1951_1747)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.44447 3.77778C9.44447 5.86419 7.7531 7.55556 5.66669 7.55556C3.58028 7.55556 1.88892 5.86419 1.88892 3.77778C1.88892 1.69137 3.58028 0 5.66669 0C7.7531 0 9.44447 1.69137 9.44447 3.77778ZM7.55558 3.77778C7.55558 4.82098 6.7099 5.66667 5.66669 5.66667C4.62349 5.66667 3.7778 4.82098 3.7778 3.77778C3.7778 2.73457 4.62349 1.88889 5.66669 1.88889C6.7099 1.88889 7.55558 2.73457 7.55558 3.77778Z"
          fill="currentColor"
        />

        <path
          d="M9.44444 11.3333C9.44444 10.8117 9.0216 10.3889 8.5 10.3889H2.83333C2.31174 10.3889 1.88889 10.8117 1.88889 11.3333V17H0V11.3333C0 9.76848 1.26853 8.5 2.83333 8.5H8.5C10.0648 8.5 11.3333 9.76848 11.3333 11.3333V17H9.44444V11.3333Z"
          fill="currentColor"
        />

        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.7407 4.40719C15.7407 5.79813 14.6131 6.92571 13.2222 6.92571C11.8312 6.92571 10.7036 5.79813 10.7036 4.40719C10.7036 3.01625 11.8312 1.88867 13.2222 1.88867C14.6131 1.88867 15.7407 3.01625 15.7407 4.40719ZM14.4814 4.40719C14.4814 5.10266 13.9177 5.66645 13.2222 5.66645C12.5267 5.66645 11.9629 5.10266 11.9629 4.40719C11.9629 3.71172 12.5267 3.14793 13.2222 3.14793C13.9177 3.14793 14.4814 3.71172 14.4814 4.40719Z"
          fill="currentColor"
        />

        <path
          d="M15.7407 9.12912C15.7407 8.78139 15.4587 8.49949 15.111 8.49949H11.3332C10.9855 8.49949 10.5708 8.78139 10.5708 9.12912L9.44434 8.49949C9.44434 7.45629 10.29 7.24023 11.3332 7.24023H15.111C16.1542 7.24023 16.9999 8.08592 16.9999 9.12912V12.9069H15.7407V9.12912Z"
          fill="currentColor"
        />
      </g>

      <defs>
        <clipPath id="clip0_1951_1747">
          <rect width="17" height="17" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
